import { render } from "./Footer.vue?vue&type=template&id=2b554a35&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=2b554a35&lang=scss&scoped=true"

import exportComponent from "/Users/andyhsieh/Desktop/tourist-site-project-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b554a35"]])

export default __exports__